"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatar = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledAvatar = (0, styles_1.styled)(material_1.Avatar)({
    height: 200,
    width: 200,
});
//# sourceMappingURL=index.js.map